import React from 'react';
import classNames from 'classnames';

import './styles.css';

import alertIcon from './assets/alert.svg';

const ErrorBlock = ({
  children,
  className
}: {
  children: any;
  className?: string;
}) => {
  return (
    <div className={classNames(className, 'Error')}>
      <img src={alertIcon} className="alertIcon" alt="warning" />
      <div className="message">{children}</div>
    </div>
  );
};

export default ErrorBlock;
